export default class ListenTaskInfo {
  CreateTasksEventFn?: Function;
  RemoveTaskEventFn?: Function;

  constructor(value: Partial<ListenTaskInfo> = null) {
    Object.assign(this, value);
  }
}
